// filterNode.js
import { Position } from 'reactflow';
import { BaseNode } from './BaseNode';

export const FilterNode = ({ id, data }) => {
    return (
        <BaseNode
            id={id}
            data={data}
            title="Filter"
            handles={[
                { type: 'target', position: Position.Left, id: `${id}-input` },
                { type: 'source', position: Position.Right, id: `${id}-output` }
            ]}
        >
            <div className="text-sm text-gray-500">
                <span>Filter data stream</span>
            </div>
        </BaseNode>
    );
};
